(function() {

    'use strict';

    angular.module('app').
    controller('CarriersZonePostcodeController', CarriersZonePostcodeController);

    CarriersZonePostcodeController.$inject = ['Location', 'CarrierZonePostcodesWWTableService', '$routeParams', '$filter'];

    function CarriersZonePostcodeController(Location, CarrierZonePostcodesWWTableService, $routeParams, $filter) {

        var vm = this;
        vm.id = $routeParams.id;
        /*vm.isInputInvalid = isInputInvalid;
        vm.searchForZipcode = searchForZipcode;*/
        vm.addPostcode = addPostcode;
        init();
        function initTable() {
            Location.Country({
                // name: model
            }, function (data) {
                vm.countries = data;
                vm.zonesPostcodes = new CarrierZonePostcodesWWTableService(data).tableData;
            }, function (err) {

            });
        }
        function init() {
            initTable();
        }
        /*function isInputInvalid(form, name) {
            return (form.$submitted && form[name].$invalid) || (form[name].$invalid && form[name].$touched);
        }
        function searchForZipcode(country, model = '', size = 2000) {
            vm.searchingPostcode = true;
            vm.postCodes = [];
            Location.ZipCode({
                country: country ? country.code : 'None',
                size: size,
                sort: 'code',
                code: model
            }, function (data) {
                vm.postCodes = buildStates(data.content);
                if (!data.content.length) {
                    vm.postCodes = [{
                        code: 'No post code found'
                    }];
                } else {
                    vm.searchingPostcode = false;
                }
            }, function (err) {
                vm.postCodes = [{
                    code: 'No post code found'
                }];
            })
        }*/
        function addPostcode(...forms) {
            angular.forEach(forms, form=>{
                form.$setSubmitted();
                if(form.$invalid)
                    return
                form.$setPristine();
            });
            const item = {
                country: angular.getObjVal(vm, 'zone.location.country.name'),
                postcode: angular.getObjVal(vm, 'zone.location.code'),
                suburb: angular.getObjVal(vm, 'zone.location.name'),
                action: {
                    type:'button',
                    buttons: [{
                        text: 'delete',
                        class: 'btn btn-danger',
                        action: row => {
                            vm.zonesPostcodes.data.splice(vm.zonesPostcodes.data.indexOf(row),1);
                        }
                    }]
                }
            };
            vm.zonesPostcodes.data.push(item);
            vm.zonesPostcodes.data = $filter('orderBy')(vm.zonesPostcodes.data, row=>row.country || row.postcode || row.suburb);

            vm.zone.location = null;
            angular.forEach(forms, form=>{
                form.$setPristine();
                form.$setUntouched();
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/carriers/CarriersZonePostcodeController.js